import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import {
  Button,
  Grid,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { EditOutlined, DeleteOutline, ChevronLeft, ChevronRight } from "@mui/icons-material";
import _ from "lodash";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";

//Services
import LocationApi from "Services/Location";

//Modals
import UpdateLocationModal from "Pages/Modals/Location/UpdateLocation";
import DeleteLocationModal from "Pages/Modals/Location/DeleteLocation";

const ListLocation = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const [row, setRow] = useState([]);
  const [locationId, setLocationId] = useState(null);

  //Pagination
  const [page, setPage] = useState(1); // 1-indexed
  const [pageSize, setPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(1);

  // Modals
  const [updateLocationModal, setUpdateLocationModal] = useState(false);
  const handleOpenUpdateLocationModal = (rowData) => {
    setLocationId(rowData?._id);
    setUpdateLocationModal(true);
  };
  const handleCloseUpdateLocationMoal = () => {
    setUpdateLocationModal(false);
    getLocationList();
  };

  const [deleteLocationModal, setdeletelocationModal] = useState(false);
  const handleOpenDeleteLocation = (rowData) => {
    setLocationId(rowData?._id);
    setdeletelocationModal(true);
  };
  const handleCloseDeleteLocation = () => {
    setdeletelocationModal(false);
    getLocationList();
  };

  // Get location list api
  const getLocationList = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalRecords(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    const params = { page, limit: pageSize };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    LocationApi.getServiceArea(params).then(onSuccess, onFailure);
  }, [page, pageSize, demoaccount_id, dispatch]);

  useEffect(() => {
    getLocationList();
  }, [getLocationList]);

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    location: data?.locationName,
    country: data?.countryId,
    row: data,
  }));

  // Pagination Logic
  const totalPagesCount = Math.ceil(totalRecords / pageSize);

  const renderPagination = () => {
    let pages = [];
    const internalPage = page - 1; // 0-indexed for internal calc

    if (totalPagesCount <= 5) {
      for (let i = 0; i < totalPagesCount; i++) {
        pages.push(i);
      }
    } else {
      if (internalPage < 3) {
        pages = [0, 1, 2, "...", totalPagesCount - 1];
      } else if (internalPage > totalPagesCount - 4) {
        pages = [0, "...", totalPagesCount - 3, totalPagesCount - 2, totalPagesCount - 1];
      } else {
        pages = [0, "...", internalPage - 1, internalPage, internalPage + 1, "...", totalPagesCount - 1];
      }
    }

    return pages.map((item, index) => {
      if (item === "...") {
        return (
          <span key={index} className={classes.pageDots}>
            ...
          </span>
        );
      }

      return (
        <Button
          key={item}
          className={internalPage === item ? classes.pageButtonActive : classes.pageButton}
          onClick={() => setPage(item + 1)}
        >
          {item + 1}
        </Button>
      );
    });
  };

  return (
    <Box className={classes.root}>
      {/* Header Container */}
      <Box className={classes.headerContainer}>
        <Typography className={classes.pageTitle}>List Location</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / Zone Management / <span>List Location</span>
        </Typography>
      </Box>

      {/* Data Table */}
      <TableContainer component={Paper} elevation={0} className={classes.tableWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 0.5 }}>
                S.No
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 2 }}>
                Location
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 2 }}>
                Country
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1, textAlign: "right" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataRows.map((rowItem) => (
              <TableRow key={rowItem.sno} className={classes.tableRow}>
                <TableCell className={classes.tableCell} style={{ flex: 0.5 }}>
                  {rowItem.sno}
                </TableCell>
                <TableCell className={`${classes.tableCell} ${classes.boldText}`} style={{ flex: 2 }}>
                  {rowItem.location}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 2 }}>
                  {rowItem.country}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1, textAlign: "right", display: "flex", justifyContent: "flex-end" }}>
                  <Box
                    component="span"
                    className={classes.actionButton}
                    onClick={() => handleOpenUpdateLocationModal(rowItem.row)}
                  >
                    <EditOutlined fontSize="small" /> Edit
                  </Box>
                  <Box
                    component="span"
                    className={classes.actionDeleteButton}
                    onClick={() => handleOpenDeleteLocation(rowItem.row)}
                  >
                    <DeleteOutline fontSize="small" /> Delete
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {dataRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} style={{ textAlign: "center", padding: "32px" }}>
                  <Typography variant="body2" color="textSecondary">
                    No records found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Box className={classes.paginationContainer}>
          <Typography className={classes.paginationText}>
            Showing {(page - 1) * pageSize + (dataRows.length > 0 ? 1 : 0)} to{" "}
            {Math.min(page * pageSize, totalRecords)} of {totalRecords} results
          </Typography>

          <Box className={classes.paginationControls}>
            <ChevronLeft
              className={`${classes.pageArrow} ${page === 1 ? "disabled" : ""}`}
              onClick={() => page > 1 && setPage(page - 1)}
            />

            {renderPagination()}

            <ChevronRight
              className={`${classes.pageArrow} ${page === totalPagesCount ? "disabled" : ""}`}
              onClick={() => page < totalPagesCount && setPage(page + 1)}
            />
          </Box>
        </Box>
      </TableContainer>

      <UpdateLocationModal
        open={updateLocationModal}
        handleClose={handleCloseUpdateLocationMoal}
        locationId={locationId}
      />
      <DeleteLocationModal
        openDialog={deleteLocationModal}
        id={locationId}
        handleClose={handleCloseDeleteLocation}
      />
    </Box>
  );
};

export default ListLocation;
